class ProductPrice extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    this.compare_price = this.querySelector(".product-price--compare"), 
    this.price = this.querySelector(".product-price--original"), 
    this.reference_unit = this.querySelector(".product-price--reference-unit"), 
    this.reference_value = this.querySelector(".product-price--reference-value"), 
    this.unit_price = this.querySelector(".product-price--unit-price"), 
    this.unit_price_container = this.querySelector(".product-price--unit-container"), 
    this.rtx_subs = document.querySelector(".product-page--wrapper .rtx-subscription"),
    this.firstVariant = JSON.parse(this.querySelector(".current-variant-json").innerHTML),
    this.currentVariant = this.firstVariant,
    this.updatePrices(this.firstVariant),

    this.updatePriceListener()
  }
  disconnectedCallback() {
    window.off(`theme:product:${this.dataset.id}:variantChanged.ProductPrice`);
    window.off(`theme:product:${this.dataset.id}:subscriptionChanged`);
  }
  updatePriceListener() {
    window.on(`theme:product:${this.dataset.id}:variantChanged.ProductPrice`, ({
			detail: {	variant: e }
    }) => {
			this.updatePrices(e);
    })

    window.on(`theme:product:${this.dataset.id}:subscriptionChanged`, () => {
			this.updatePrices(this.currentVariant);
    })
  }
  updatePrices(e) {
    this.currentVariant = e;
    const sellingPlanId = this.getSellingPlanId();
    var priceToUse = e.price;
    if(sellingPlanId != ''){
      e.selling_plan_allocations.forEach(sellingPlan => {
        if(sellingPlan.selling_plan_id == Number(sellingPlanId))
          priceToUse = sellingPlan.price;
      });
    }
    e ? (this.removeAttribute("style"), 
    this.price.innerHTML = theme.utils.formatMoney(priceToUse), 
    e.compare_at_price > e.price ? (this.compare_price.innerHTML = theme.utils.formatMoney(e.compare_at_price), 
    this.compare_price.style.display = "inline-block") : this.compare_price.style.display = "none", 
    e.unit_price_measurement ? (this.unit_price.innerHTML = theme.utils.formatMoney(e.unit_price), 
    this.reference_unit.innerHTML = e.unit_price_measurement.reference_unit, 1 === e.unit_price_measurement.reference_value && this.reference_value ? this.reference_value.style.display = "none" : this.reference_value && (this.reference_value.innerHTML = e.unit_price_measurement.reference_value, 
    this.reference_value.style.display = "block"), this.unit_price_container.style.display = "flex") : this.unit_price_container.style.display = "none") : this.style.display = "none"
  }
  getSellingPlanId(){
    const urlString = window.location.href;
    const url = new URL(urlString);
    var sellingPlan = url.searchParams.get('selling_plan');
    if(sellingPlan){
      return sellingPlan;
    }
    if(this.rtx_subs){
      var radioChecked = this.rtx_subs.querySelector('input[name="purchaseType"]:checked');

      if(radioChecked && radioChecked.value != 'purchaseTypeOneTime'){
        var commonParent = radioChecked.closest('.rtx-subscription-label');
        var selectedValue = commonParent.querySelector('.rtx-subscription-dropdown');
        return selectedValue.value;
      }
    }
    return '';
  }

  getValueFromRTX(variant){

    this.getSellingPlanId();
    
  }
}
const productPriceEl = customElements.get("product-price-root");
productPriceEl || customElements.define("product-price-root", ProductPrice);